import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuggestionsComponent } from './suggestions.component';
import { SuggestionCarouselModule } from '../suggestion-carousel/suggestion-carousel.module';

@NgModule({
  declarations: [SuggestionsComponent],
  imports: [
    CommonModule,
    SuggestionCarouselModule
  ],
  exports: [SuggestionsComponent]
})
export class SuggestionsModule {}
